<template>
  <UISkeletonLoaderSPA />
</template>

<script lang="ts" setup>
import { routeNames } from '@manager/router/route-names';
import { useAuthStore } from '@manager/store/auth-store';
import { usePermissionStore } from '@manager/store/permission-store';
import UISkeletonLoaderSPA from 'shared/ui/registry/kinnovis/ui-skeleton-loaders/UISkeletonLoaderSPA.vue';
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const permissionStore = usePermissionStore();
const authStore = useAuthStore();

const isAuthenticated = computed(() => {
  return authStore.isAuthenticated && permissionStore.permissions;
});

onMounted(async () => {
  if (isAuthenticated.value) {
    await authStore.logout();
  } else {
    router.replace({ name: routeNames.login });
  }
});
</script>

<style scoped lang="scss"></style>
